import { IconProps } from "../types/icon";

export const ScooterIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4M14 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
        <path d="M5.5 14.5a.5.5 0 0 1-.5-.491A3 3 0 0 0 2 11a1 1 0 0 1 0-2 4.98 4.98 0 0 1 4 2.031V11h3.884l2.253-2.534L11.142 2H9a1 1 0 0 1 0-2h3a1 1 0 0 1 .988.848l1.2 7.779a1 1 0 0 1-.241.816l-4.2 4.721A1 1 0 0 1 9 14.5z" />
      </g>
    </svg>
  );
};
